// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { SubscriptionRoutes } from "..";
import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { StyledLink } from "components/links/StyledLink";
import { IBilling, ICreditCard } from "store/entities/billing/interfaces";
import { withVar } from "themes/helpers";

const StyledTitle = styled.h2`
  font-weight: normal;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  margin-bottom: 24px;
`;

const StyledCardRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
`;

const StyledCardIcon = styled(Icon)`
  align-self: center;
  svg {
    fill: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.primaryColor
    };
  }
`;

const StyledCardInfo = styled.p`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  font-size: 18px;
  font-weight: bold;
  margin-left: 5px;
`;

const StyledCardExpiration = styled.p`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  font-size: 16px;
  line-height: 1.4em;
  margin-bottom: 32px;
`;

interface IProps {
  billing: IBilling;
}

export const SubscriptionCardInfo: React.FC<IProps> = ({ billing }) => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const creditCard: ICreditCard = billing?.billingInfo?.creditCard || ({} as ICreditCard);
  return (
    <>
      <StyledTitle>Payment</StyledTitle>
      <StyledCardRow>
        <StyledCardIcon name={IconsEnum.CreditCard} width="20px" height="16px" />
        <StyledCardInfo>
          {creditCard.cardType} ending in *{creditCard.lastFour}
        </StyledCardInfo>
      </StyledCardRow>
      <StyledCardExpiration>
        Expiration: {creditCard.month}/{creditCard.year}
      </StyledCardExpiration>
      <StyledLink to={`${SubscriptionRoutes.AccountDetails}#billing-details`} data-testid="update-billing">
        Update billing info
      </StyledLink>
    </>
  );
};
